var cov_33y2lrjp8 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tag/styles/index.ts",
      hash = "3b6cc610e5aed99bc0aafb12a7aa5e434fea6a58",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tag/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 24
        },
        end: {
          line: 5,
          column: 50
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var tagLess = {};
import genaration from '../../utils/classname';
export var tagClass = (cov_33y2lrjp8.s[0]++, genaration(tagLess, 'tag'));